import type { HelpFile } from '../../types/help'
import { EffectiveAccessByIdentityTestIds } from '../../../testids/EffectiveAccessByIdentityTestIds'

export const effectiveAccessByIdentityHelp: HelpFile = {
  docPage: '/docs/analytics/effective-access',
  texts: {
    [EffectiveAccessByIdentityTestIds.effectiveAccessByIdentityPage]:
      'Every identity with its current effective access — use this view to audit who has access to what across all target systems.',
    [EffectiveAccessByIdentityTestIds.colActions]: null,
    [EffectiveAccessByIdentityTestIds.colIdentity]: null,
    [EffectiveAccessByIdentityTestIds.colParty]:
      'Party that owns this identity (person, organization, or AI agent).',
    [EffectiveAccessByIdentityTestIds.colStatus]: null,
    [EffectiveAccessByIdentityTestIds.colType]:
      'Type of identity — employee, contractor, technical account, etc.',
  },
}
